// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AssessmentFeedback_wrapper","grade":"AssessmentFeedback_grade","points":"AssessmentFeedback_points"};